module.exports = __webpack_public_path__ + "static/media/setupcalculatoricon.45739921.svg";